/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lyn2': {
    width: 42,
    height: 29,
    viewBox: '0 0 42 29',
    data: '<path pid="0" d="M6.071 13.408L42 0l-2.09 5.333-7.017 2.64-2.338 6.146L0 29z" _fill="#3062A9" fill-rule="nonzero"/>'
  }
})
